var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('modal',{ref:"modalAprobarCambios",attrs:{"titulo":"Aprobar Cambios","icon":"check"},on:{"guardar":_vm.updateDatos}},[_c('p',{staticClass:"text-general text-center px-5"},[_vm._v(" ¿Desea aprobar los cambios realizados de la "+_vm._s(_vm.$config.vendedor)+" ? ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }